import { render, staticRenderFns } from "./Flotas.vue?vue&type=template&id=c88a4336"
import script from "./Flotas.vue?vue&type=script&lang=js"
export * from "./Flotas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports